import type { LiveSubagent } from "@t3tools/contracts";

export interface SubagentStatusDockModel {
  readonly totalCount: number;
  readonly runningCount: number;
  readonly attentionCount: number;
  readonly tone: "active" | "attention";
}

export type ComposerDockedContent = "requests" | "subagents" | "taskPlan" | null;

const isActive = (agent: LiveSubagent): boolean =>
  agent.phase === "pending" || agent.phase === "running" || agent.phase === "waiting";

const needsAttention = (agent: LiveSubagent): boolean =>
  agent.phase === "failed" ||
  agent.phase === "stopped" ||
  (agent.phase === "waiting" &&
    (agent.waitingReason === "approval" || agent.waitingReason === "input"));

export function buildSubagentStatusDockModel(
  agents: ReadonlyArray<LiveSubagent>,
): SubagentStatusDockModel | null {
  const runningCount = agents.filter(isActive).length;
  const attentionCount = agents.filter(needsAttention).length;
  if (runningCount === 0 && attentionCount === 0) {
    return null;
  }
  return {
    totalCount: agents.length,
    runningCount,
    attentionCount,
    tone: attentionCount > 0 ? "attention" : "active",
  };
}

export function resolveComposerDockedContent(input: {
  readonly hasPendingApproval: boolean;
  readonly hasPendingUserInput: boolean;
  readonly subagents: SubagentStatusDockModel | null;
  readonly hasActiveTaskPlan: boolean;
}): ComposerDockedContent {
  if (input.hasPendingApproval || input.hasPendingUserInput) {
    return "requests";
  }
  if (input.subagents?.attentionCount) {
    return "subagents";
  }
  if (input.subagents?.runningCount) {
    return "subagents";
  }
  return input.hasActiveTaskPlan ? "taskPlan" : null;
}
